import React, { Component } from 'react';
import _ from 'lodash';
import { Modal } from 'react-bootstrap';

export default class Alert extends Component {
  constructor(props) {
    super(props);
    this.state = { visible: false };
  }

  open(title, body, yes) {
    this.yes = yes;
    this.setState({ title, body, visible: true });
  }

  openLarge(title, body, yes) {
    this.yes = yes;
    this.setState({
      title,
      body,
      visible: true,
      large: true,
    });
  }

  openLargeWithPrint(title, body, yes, printFunc) {
    this.yes = yes;
    this.state.printFunc = printFunc;
    this.setState({
      title,
      body,
      visible: true,
      large: true,
    });
  }

  onClose() {
    this.setState({ visible: false, large: false });
  }

  render() {
    let modalClass = '';
    if (this.state.large == true) {
      modalClass = 'modal-lg';
    }

    if (this.state.visible == false) {
      return <div />;
    }

    return (
      <Modal show={true} dialogClassName={modalClass} autoFocus={false}>
        <Modal.Header>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div>
              <h4 className="modal-title">{this.state.title}</h4>
            </div>
            <div>
              {this.state.printFunc != null && (
                <span style={{ marginRight: 10 }}>
                  {' '}
                  <button
                    onClick={() => {
                      this.state.printFunc();
                    }}
                    type="button"
                    className="btn btn-info "
                    style={{ marginRight: 10 }}
                    data-dismiss="modal"
                  >
                    Print
                  </button>
                  <button
                    onClick={() => {
                      this.onClose();
                    }}
                    type="button"
                    className="btn btn-danger"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                </span>
              )}

              <button
                type="button"
                onClick={() => {
                  this.onClose();
                }}
                className="close"
                data-dismiss="modal"
              >
                &times;
              </button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div style={{ whiteSpace: 'pre-line' }}>{this.state.body}</div>
        </Modal.Body>
        <Modal.Footer>
          {this.state.printFunc != null && (
            <button
              onClick={() => {
                this.state.printFunc();
              }}
              type="button"
              className="btn btn-info"
              data-dismiss="modal"
            >
              Print
            </button>
          )}

          <button
            onClick={() => {
              if (this.yes) {
                this.yes();
              }
              this.onClose();
            }}
            type="button"
            className="btn btn-danger"
            data-dismiss="modal"
          >
            {this.state.printFunc != null ? 'Close' : 'Ok'}
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}
